import gql from "graphql-tag";

export const GET_HOTELS = gql`
  query hotels($query: String) {
    hotels(query: $query) {
      id
      name
      phone
      address
    }
  }
`;

export const GET_HOTEL = gql`
  query hotel($id: String) {
    hotel(id: $id) {
      id
      name
      phone
      address
      bookings {
        id
        customer {
          firstName
          lastName
        }
        checkIn
        checkOut
        customerPayment {
          total {
            amount
          }
        }
      }

    }
  }
`;